import React from 'react';
import PropTypes from 'prop-types';

const RestrictedEmails = props => {
  let restrictedEmails = '';
  if (props.restrictedEmails) {
    restrictedEmails = props.restrictedEmails.map(email => (
      /* eslint-disable jsx-a11y/anchor-is-valid */
      <li key={email}>
        <a>{email}</a>
      </li>
      /* eslint-enable jsx-a11y/anchor-is-valid */
    ));
  }

  return (
    <div className="restricted">
      {props.duplicateEmailsExist ? (
        <p>{props.translations['also-outside-approved-domains']}</p>
      ) : (
        <h3>{props.translations['outside-approved-domains']}</h3>
      )}
      <ul>{restrictedEmails}</ul>
      {!props.duplicateEmailsExist && (
        <button
          onClick={() => props.displayModal('')}
          style={{ backgroundColor: props.color, borderColor: props.color }}
        >
          {props.translations.done}
        </button>
      )}
    </div>
  );
};

RestrictedEmails.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  restrictedEmails: PropTypes.array.isRequired,
  displayModal: PropTypes.func,
  duplicateEmailsExist: PropTypes.bool,
};

RestrictedEmails.defaultProps = {
  displayModal: () => {},
  duplicateEmailsExist: false,
};

export default RestrictedEmails;
